export default "__VITE_ASSET__BBfVYNxn__"